import { render, staticRenderFns } from "./user-provider-info.vue?vue&type=template&id=a448da20&scoped=true"
import script from "./user-provider-info.vue?vue&type=script&lang=js"
export * from "./user-provider-info.vue?vue&type=script&lang=js"
import style0 from "./user-provider-info.vue?vue&type=style&index=0&id=a448da20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a448da20",
  null
  
)

export default component.exports